/**
 * Created by jiachenpan on 16/11/18.
 */

import moment from 'moment'
import { getToken } from '@/utils/auth'
import { Message, MessageBox, Notification } from 'element-ui'

export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time)
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    }
}

// 格式化时间
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * @param {Sting} input value
 * @returns {number} output value
 */
export function byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) s++
        else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xdc00 && code <= 0xdfff) i--
    }
    return s
}

export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

export function param(json) {
    if (!json) return ''
    return cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ''
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
    ).join('&')
}

export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}')
}

export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

export function objectMerge(target, source) {
    /* Merges two  objects,
     giving the last one precedence */

    if (typeof target !== 'object') {
        target = {}
    }
    if (Array.isArray(source)) {
        return source.slice()
    }
    Object.keys(source).forEach(property => {
        const sourceProperty = source[property]
        if (typeof sourceProperty === 'object') {
            target[property] = objectMerge(target[property], sourceProperty)
        } else {
            target[property] = sourceProperty
        }
    })
    return target
}

export function toggleClass(element, className) {
    if (!element || !className) {
        return
    }
    let classString = element.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
    }
    element.className = classString
}

export const pickerOptions = [
    {
        text: '今天',
        onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().toDateString())
            end.setTime(start.getTime())
            picker.$emit('pick', [start, end])
        },
    },
    {
        text: '最近一周',
        onClick(picker) {
            const end = new Date(new Date().toDateString())
            const start = new Date()
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
        },
    },
    {
        text: '最近一个月',
        onClick(picker) {
            const end = new Date(new Date().toDateString())
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
        },
    },
    {
        text: '最近三个月',
        onClick(picker) {
            const end = new Date(new Date().toDateString())
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
        },
    },
]

export function getTime(type) {
    if (type === 'start') {
        return new Date().getTime() - 3600 * 1000 * 24 * 90
    } else {
        return new Date(new Date().toDateString())
    }
}

export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function (...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

export function uniqueArr(arr) {
    return Array.from(new Set(arr))
}

export function createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
}

export function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}
export function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += ' ' + cls
}
export function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}

// 获取 m ~ n 之间的随机整数
export function random(m, n) {
    if (m === n) return m
    if (m < n) {
        let tmp = n
        n = m
        m = tmp
    }
    return Math.floor(Math.random() * (m - n + 1) + n)
}

/**
 * 下载
 */
export function exportFile(url) {
    const aLink = document.createElement('a')
    aLink.href = url
    aLink.dispatchEvent(new MouseEvent('click', {}))
}

// 格式化 B KB MB
export function formatSize(ogSize, ops) {
    const sizeMap = ['B', 'KB', 'MB']
    ogSize = +ogSize
    let ogUnit = (ops && ops.ogUnit) || 'B'
    let targetUnit = (ops && ops.targetUnit) || 'MB'
    if (ogUnit === 'B' && ogSize < 1024 * 1024) targetUnit = 'KB'
    let ogIndex = sizeMap.findIndex(item => item === ogUnit)
    let targetIndex = sizeMap.findIndex(item => item === targetUnit)
    let df = targetIndex - ogIndex
    for (let i = 0; i < Math.abs(df); i++) {
        if (df > 0) {
            ogSize /= 1024
        } else {
            ogSize *= 1024
        }
    }
    return ogSize.toFixed(2) + targetUnit
}

/**
 * 导出文件
 * 通过a标签实现
 * url [url]
 * params [参数]
 */
/*export function exportFile(url, params = {}) {
    let paramList = [`token=${getToken()}`]
    for (let n in params) {
        paramList.push(`${n}=${params[n]}`)
    }
    const addr = paramList.length ? `${url}?${paramList.join('&')}` : url
    window.open(addr)
    // 第二种方法可以通过a标签下载
    // let aBtn = document.createElement('a')
    // aBtn.href = addr
    // aBtn.target = '_blank'
    // aBtn.click()
    // aBtn = null
}, // exportFile*/

/**
 * 格式化时间戳
 * date 时间戳
 * format moment 的 format格式
 */
export function dateFormat(date, format = 'YYYY-MM-DD HH:mm') {
    return moment(date).format(format)
}

/**
 * 重要的弹框操作警告
 * 例如：删除确认
 * */
export function confirmOperation(title, type, operationFunction, params, callback) {
    MessageBox.confirm(title ? title : '是否继续此操作?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type ? type : 'warning',
    })
        .then(() => {
            operationFunction(params)
                .then(response => {
                    const { data } = response
                    if (data.status === 200) {
                        Message({
                            type: 'success',
                            message: '操作成功!',
                        })
                    } else {
                        Message({
                            type: 'error',
                            message: '操作失败',
                        })
                    }
                    callback(data)
                })
                .catch(error => {
                    callback(error)
                    Message({
                        type: 'error',
                        message: '操作失败',
                    })
                })
        })
        .catch(() => {
            Message({
                type: 'info',
                message: '已取消操作',
            })
        })
}

/**
 * notify-提示框
 * @des: duration=0时不会自动关闭
 * @params: type: 类型 //info/warning/success/error
 * */
export function notifyOpen(title, message, duration, type) {
    Notification({
        title: title,
        message: message,
        duration: duration,
        type: type,
    })
}

/**
 * 操作返回message
 * type [success, error]
 */
export function showMessage(type, code = 0) {
    code = `MsgCode${code}`
    console.info('code: ' + code)
    if (this.$te(`Message.${code}`)) {
        Message[type](this.$t(`Message.${code}`))
    } else {
        const defaultMessage = type === 'success' ? this.$t('Message.DefaultSuccess') : this.$t('Message.DefaultError')
        Message[type](defaultMessage)
    }
}

/**
 * 遍历Object循环插入data数据
 * */
export function setObjectMapData(data, OriginObj) {
    for (let i in OriginObj) {
        for (let k in data) {
            if (i === k) {
                OriginObj[i] = data[k]
            }
        }
    }
    return OriginObj
}
